import { APP_CONSTANTS } from './src-config-miaw-constants.js';

let storageKey;
let storageName;
const isLocalStorageAvailable = () => {
  try {
    if (typeof window === "undefined") {
      console.warn("Local storage not available in this environment.");
      return false;
    }
    window?.localStorage?.getItem("test");
    if (window?.localStorage && typeof window?.localStorage === "object") {
      storageName = "localStorage";
      return true;
    }
  } catch {
    return false;
  }
  return false;
};
const isSessionStorageAvailable = () => {
  try {
    if (typeof window === "undefined") {
      console.warn("Session storage not available in this environment.");
      return false;
    }
    window?.sessionStorage.getItem("test");
    if (window?.sessionStorage && typeof window?.sessionStorage === "object") {
      storageName = "sessionStorage";
      return true;
    }
  } catch {
    return false;
  }
  return false;
};
const determineStorageType = (inLocalStorage = false) => {
  if (typeof window === "undefined") {
    console.warn("Web storage determination skipped in this environment.");
    return void 0;
  }
  return isLocalStorageAvailable() && inLocalStorage ? window.localStorage : isSessionStorageAvailable() ? window.sessionStorage : void 0;
};
const initializeWebStorage = (organizationId) => {
  if (typeof window === "undefined") {
    console.warn("Web storage initialization skipped in this environment.");
    return;
  }
  storageKey = `${APP_CONSTANTS.WEB_STORAGE_KEY}${organizationId}`;
  const storageObj = JSON.stringify({});
  if (isLocalStorageAvailable() && !localStorage.getItem(storageKey)) {
    localStorage.setItem(storageKey, storageObj);
  }
  if (isSessionStorageAvailable() && !sessionStorage.getItem(storageKey)) {
    window?.sessionStorage?.setItem(storageKey, storageObj);
  }
};
const getItemInWebStorageByKey = (key, inLocalStorage = true) => {
  if (typeof window === "undefined") {
    console.warn("Web storage retrieval skipped in this environment.");
    return void 0;
  }
  let item;
  const storage = determineStorageType(inLocalStorage);
  if (storage) {
    const storageItem = storage.getItem(storageKey);
    const storageObj = storageItem && JSON.parse(storageItem) || {};
    item = storageObj[key];
  }
  return item;
};
const setItemInWebStorage = (key, value, inLocalStorage = true) => {
  if (typeof window === "undefined") {
    console.warn("Web storage setting skipped in this environment.");
    return;
  }
  const storage = determineStorageType(inLocalStorage);
  if (storage) {
    const storageItem = storage.getItem(storageKey);
    const storageObj = storageItem && JSON.parse(storageItem) || {};
    storageObj[key] = value;
    storage.setItem(storageKey, JSON.stringify(storageObj));
  }
};
const clearWebStorage = () => {
  if (typeof window === "undefined") {
    console.warn("Web storage clearing skipped in this environment.");
    return;
  }
  if (isLocalStorageAvailable()) {
    localStorage.removeItem(storageKey);
  }
  if (isSessionStorageAvailable()) {
    window?.sessionStorage?.removeItem(storageKey);
  }
};

export { clearWebStorage, determineStorageType, getItemInWebStorageByKey, initializeWebStorage, isLocalStorageAvailable, isSessionStorageAvailable, setItemInWebStorage, storageKey };
//# sourceMappingURL=src-utils-miaw-web-storage-utils.js.map
